import { ORM } from 'redux-orm';

import {commitDb, apiGet, initDb} from './actions';
import _ from 'lodash';
import {parse, format} from 'url';

export class DB {
    constructor(models, autoPopulateModelGetters=true) {
        let orm = new ORM();

        models.forEach((m) => {
            orm.register(m);

            if ( autoPopulateModelGetters ) {
                // define in object getters for models, we can check
                // how session is going on to raise clear exception if need
                Object.defineProperty(this, m.modelName, {
                    get: function() {
                        return this._session[m.modelName];
                    }
                })
            }

        });

        this._orm = orm;
        this._session = null;
        this._store = null;
    }

    setStore(store) {
        this._store = store;
        this.store.dispatch(initDb(this.orm.getEmptyState()));
    }

    get store() {
        return this._store;
    }

    get orm() {
        return this._orm;
    }

    begin(dbState=null) {
        if ( dbState === null ) {
            dbState =  this.orm.getEmptyState();
        }

        this._session = this.orm.session({...dbState});
    }

    commit() {
        this._store.dispatch(commitDb(this.session.state));
    }

    get session() {
        /* @todo: check is not null */
        return this._session;
    }

    loadList(model, query_args) {
        if (!_.isString(model)) {
            model = model.modelName;
        }
        let apiListUrl = _.find(this.orm.registry, (m) => m.modelName === model).api.listUrl;
        let url = parse(apiListUrl, true);
        url.search = null;
        _.forOwn(query_args, (k, v) => {
            if (k)
                url.query[v] = k
        });
        url = format(url);

        this.store.dispatch(apiGet(url, this));
    }
}


// WEBPACK FOOTER //
// ./src/lib/worm/db.js